import { InputField, InputSelectFieldOptions } from 'components/molecules'
import { PRODUCTABLE_TYPE_OPTIONS } from 'domains/product/constants'

const ProductProductableTypeFilterField = () => (
  <>
    <InputField
      formGroupClassName={ 'mr-3' }
      type={ 'select' }
      name={ 'productable_type' }
      label={ 'PRODUCTABLE TYPE' }
      bsSize={ 'sm' }
    >
      <InputSelectFieldOptions
        options={ PRODUCTABLE_TYPE_OPTIONS }
      />
    </InputField>
  </>
)

export default ProductProductableTypeFilterField
